import { Box, Container, Grid, VStack, HStack, Text, Link } from '@chakra-ui/react';
import React from 'react';
import { FacebookIcon } from 'icons/FacebookIcon';
import { InstagramIcon } from 'icons/InstagramIcon';
import { LinkedInIcon } from 'icons/LinkedinIcon';

interface IFooterLink {
  label: string;
  href: string;
}

interface IFooterSection {
  title: string;
  links: IFooterLink[];
}

const footerSections: IFooterSection[] = [
  {
    title: 'Məhsul',
    links: [
      { label: 'Xüsusiyyətlər', href: '#features' },
      { label: 'Qiymətlər', href: '#pricing' },
      { label: 'İnteqrasiyalar', href: '#integrations' },
      { label: 'Yenilənmələr', href: '#updates' }
    ]
  },
  {
    title: 'Şirkət',
    links: [
      { label: 'Haqqımızda', href: '#about' },
      { label: 'Bloq', href: '#blog' },
      { label: 'Karyera', href: '#careers' },
      { label: 'Əlaqə', href: '#contact' }
    ]
  },
  {
    title: 'Resurslar',
    links: [
      { label: 'Sənədlər', href: '#docs' },
      { label: 'Yardım Mərkəzi', href: '#help' },
      { label: 'İcma', href: '#community' },
      { label: 'Vebinarlar', href: '#webinars' }
    ]
  },
  {
    title: 'Hüquqi',
    links: [
      { label: 'Məxfilik Siyasəti', href: '#privacy' },
      { label: 'Xidmət Şərtləri', href: '#terms' },
      { label: 'Kukilər Siyasəti', href: '#cookies' },
      { label: 'GDPR', href: '#gdpr' }
    ]
  }
];

const socialLinks = [
  { icon: <InstagramIcon />, href: 'https://instagram.com/caspipos', label: 'Facebook' },
  { icon: <FacebookIcon />, href: 'https://www.linkedin.com/company/caspipos', label: 'Twitter' },
  { icon: <LinkedInIcon />, href: '   ', label: 'Instagram' }
];

export const Footer: React.FC = () => {
  return (
    <Box bg="gray.900" color="white" pt={16} pb={8}>
      <Container maxW="container.xl">
        <Grid
          css={{
            '@media (min-width: 350px)': {
              gridTemplateColumns: 'repeat(2, 1fr)'
            },
            '@media (min-width: 768px)': {
              gridTemplateColumns: 'repeat(4, 1fr)'
            }
          }}
          gap={8}
          mb={12}
        >
          {footerSections.map((section, index) => (
            <VStack key={index} align="start">
              <Text fontSize="sm" fontWeight="600" color="white">
                {section.title}
              </Text>
              <VStack align="start">
                {section.links.map((link, linkIndex) => (
                  <Link
                    key={linkIndex}
                    href={link.href}
                    fontSize="sm"
                    color="gray.400"
                    _hover={{
                      color: 'white',
                      textDecoration: 'none'
                    }}
                    transition="color 0.2s"
                  >
                    {link.label}
                  </Link>
                ))}
              </VStack>
            </VStack>
          ))}
        </Grid>

        <HStack justify={{base:"center",md:"space-between"}} align="center" flexWrap="wrap" gap={4}>
          <Text fontSize="sm" color="gray.400">
            © 2025 CaspiPos. Bütün hüquqlar qorunur.
          </Text>
          <HStack>
            {socialLinks.map((social, index) => (
              <Link
                key={index}
                href={social.href}
                aria-label={social.label}
                fontSize="xl"
                _hover={{
                  transform: 'translateY(-2px)',
                  opacity: 0.8
                }}
                transition="all 0.2s"
              >
                {social.icon}
              </Link>
            ))}
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
};
